import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            资源分类导航
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            八大资源分类，覆盖影视、音乐、软件、电子书等热门领域，助你快速定位所需资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string; tagBg: string; tagText: string }> = {
              accent: {
                bg: 'bg-accent-50 hover:bg-accent-100',
                iconBg: 'bg-accent-100',
                iconColor: 'text-accent-600',
                tagBg: 'bg-accent-100',
                tagText: 'text-accent-700',
              },
              primary: {
                bg: 'bg-primary-50 hover:bg-primary-100',
                iconBg: 'bg-primary-100',
                iconColor: 'text-primary-600',
                tagBg: 'bg-primary-100',
                tagText: 'text-primary-700',
              },
              secondary: {
                bg: 'bg-secondary-50 hover:bg-secondary-100',
                iconBg: 'bg-secondary-100',
                iconColor: 'text-secondary-600',
                tagBg: 'bg-secondary-100',
                tagText: 'text-secondary-700',
              },
            };
            const colors = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`${colors.bg} rounded-xl p-5 transition-all duration-200 group cursor-pointer`}
              >
                <span className={`w-11 h-11 flex items-center justify-center rounded-xl ${colors.iconBg} ${colors.iconColor} text-lg mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={cat.icon}></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1.5">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {cat.description}
                </p>
                <span className={`inline-block px-2.5 py-1 rounded-md ${colors.tagBg} ${colors.tagText} text-xs font-medium`}>
                  {cat.count.toLocaleString()} 个资源
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}